// REACT
import { createContext } from "react";

export const maincontext = createContext({});
